import Vue from 'vue'
import VueRouter from 'vue-router'
import Entidades from './components/Entidades.vue'
import ObrasServicosDetails from './components/ObrasServicosDetails.vue'
import ObrasServicos from './components/ObrasServicos.vue'
import ObraServico from './components/ObraServico.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Entidades, props: (route) => {
      if (route.query && route.query.all) {
        return { all: true}
      } else {
        return { }
      }
    }
  },
  { path: '/:entidade', component: ObrasServicosDetails, props: (route) => {
      const entidade = Number.parseInt(route.params.entidade, 10)
      if (Number.isNaN(entidade)) {
        return 0
      }
      if (route.query && route.query.all) {
        return { entidade, all: true}
      } else {
        return { entidade }
      }
    } 
  },
  { path: '/:entidade/:id', component: ObraServico, props: (route) => {
      const entidade = Number.parseInt(route.params.entidade, 10)
      if (Number.isNaN(entidade)) {
        return 0
      }
      const id = Number.parseInt(route.params.id, 10)
      if (Number.isNaN(id)) {
        return 0
      }
      if (route.query && route.query.all) {
        return { id, entidade, all: true}
      } else {
        return { id, entidade }
      }
    } 
  },
]

export const router = new VueRouter({
    routes
})